(() => {
  const node = document.getElementById('BrowserLanguageFallbackConfig');
  if (!node) return;

  let config;
  try { config = JSON.parse(node.textContent); } catch { return; }
  if (config.designMode) return;

  const choiceKey = 'peb_language_choice';
  const visitKey = 'peb_language_visit';
  const formId = 'BrowserLanguageFallbackForm';
  const languages = new Map(config.languages.map(language => [language.locale.toLowerCase(), language.locale]));

  function read(key, persistent) {
    try {
      const value = (persistent ? localStorage : sessionStorage).getItem(key);
      if (value) return value;
    } catch { /* Cookie storage remains available in some restricted browsers. */ }
    try {
      const cookie = document.cookie.split('; ').find(value => value.startsWith(key + '='));
      return cookie ? decodeURIComponent(cookie.slice(key.length + 1)) : null;
    } catch { return null; }
  }

  function write(key, value, persistent) {
    try { (persistent ? localStorage : sessionStorage).setItem(key, value); } catch { /* Try the cookie fallback. */ }
    try {
      document.cookie = key + '=' + encodeURIComponent(value) + '; Path=/; SameSite=Lax; Max-Age=' +
        (persistent ? 31536000 : 1800) + (location.protocol === 'https:' ? '; Secure' : '');
    } catch { /* Skip automatic switching if a loop guard cannot be saved. */ }
    return read(key, persistent) === value;
  }

  function rememberSelection(form, control) {
    if (!form || form.id === formId) return;
    let action;
    try { action = new URL(form.action, location.href); } catch { return; }
    if (action.origin !== location.origin || !action.pathname.endsWith('/localization')) return;
    const field = control && /^(locale_code|language_code)$/.test(control.name)
      ? control : form.querySelector('select[name="locale_code"], select[name="language_code"], input[name="locale_code"], input[name="language_code"]');
    const locale = field && languages.get(field.value.toLowerCase());
    if (locale) write(choiceKey, locale, true);
  }

  document.addEventListener('click', event => {
    const control = event.target.closest && event.target.closest('button[name="locale_code"], button[name="language_code"]');
    if (control) rememberSelection(control.form, control);
  }, true);
  document.addEventListener('submit', event => rememberSelection(event.target, event.submitter), true);

  const visited = read(visitKey, false);
  const guarded = write(visitKey, '1', false);
  if (visited || !guarded || read(choiceKey, true)) return;
  if (config.country !== 'HK' || config.locale.toLowerCase() !== 'en') return;
  if (/bot|crawler|spider|lighthouse/i.test(navigator.userAgent)) return;

  const url = new URL(location.href);
  if (['locale', 'language', 'lang'].some(key => url.searchParams.has(key))) return;
  const segment = url.pathname.split('/')[1].toLowerCase();
  if (/^(?:[a-z]{2}|zh(?:-[a-z0-9]{2,8})+)$/.test(segment)) return;
  if (config.languages.some(language => {
    const root = new URL(language.root, location.origin).pathname.replace(/[/]$/, '');
    return root && (url.pathname === root || url.pathname.startsWith(root + '/'));
  })) return;
  try { if (document.referrer && new URL(document.referrer).origin === location.origin) return; } catch { return; }

  function preferredLocale() {
    for (const preference of navigator.languages || [navigator.language]) {
      const code = preference.toLowerCase().replace(/_/g, '-');
      let candidate = code;
      if (code === 'zh' || code.startsWith('zh-')) {
        if (/(?:^|-)hant(?:-|$)/.test(code)) candidate = 'zh-tw';
        else if (/(?:^|-)hans(?:-|$)/.test(code)) candidate = 'zh-cn';
        else if (/(?:^|-)(tw|hk|mo)(?:-|$)/.test(code) || code === 'zh') candidate = 'zh-tw';
        else if (/(?:^|-)(cn|sg)(?:-|$)/.test(code)) candidate = 'zh-cn';
        else continue;
      }
      const match = languages.get(candidate) || languages.get(candidate.split('-')[0]);
      if (match) return match;
    }
    return null;
  }

  const target = preferredLocale();
  if (!target || !/^zh-(tw|cn)$/i.test(target)) return;
  const form = document.getElementById(formId);
  if (!form) return;
  form.elements.language_code.value = target;
  const returnFields = [...form.querySelectorAll('input[name="return_to"]')];
  if (!returnFields.length) {
    const field = document.createElement('input');
    field.type = 'hidden';
    field.name = 'return_to';
    form.append(field);
    returnFields.push(field);
  }
  returnFields.forEach(field => { field.value = url.pathname + url.search + url.hash; });
  HTMLFormElement.prototype.submit.call(form);
})();
